import { createSlice } from '@reduxjs/toolkit';
import { exportScheduleProgress, fetchSchedules } from './Utils/ScheduleUtils';

const ScheduleSlice = createSlice({
    name: 'Schedules',
    initialState: {
        filters: {
            "filter[id]": "",
            "filter[name]": "",
            "filter[class_id]": "",
            "filter[tentor_id]": "",
            "filter[place]": "",
            "sort": "",
            "page": "",
            "include": "tentor,classes,course,material,material.submaterials",
            "include_attendance_count": 1
        },
        data: [],
        detail: {},
        isLoading: false,
        isExport: false
    },
    reducers: {
        setFilters: (state, action) => {
            state.filters = action.payload;
        },
        setDetail: (state, action) => {
            state.detail = action.payload;
        },
    },
    extraReducers: {
        [fetchSchedules.pending]: (state) => {
            state.isLoading = true;
        },
        [fetchSchedules.fulfilled]: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        [fetchSchedules.rejected]: (state) => {
            state.isLoading = false;
        },
        [exportScheduleProgress.pending]: (state) => {
            state.isExport = true;
        },
        [exportScheduleProgress.fulfilled]: (state) => {
            state.isExport = false;
        },
        [exportScheduleProgress.rejected]: (state) => {
            state.isExport = false;
        },
    }
});

export const { setFilters, setDetail } = ScheduleSlice.actions;

export default ScheduleSlice.reducer;